import { useAppTranslation } from 'src/i18n/hooks';
import { useState } from 'react';

export interface SubMenu {
  label: string;
  key: string;
  link?: string;
}

export interface IMenuItem {
  label: string;
  key: string;
  link?: string;
  subMenus: SubMenu[];
  id?: string;
  isNew?: boolean;
}

interface Props {
  data: IMenuItem;
  onClick: (key: string) => void;
}

const MenuItem = ({ data, onClick }: Props) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const { t } = useAppTranslation('navbar');

  return (
    <>
      {data.subMenus && data.subMenus.length > 0 ? (
        <div id={data?.id}>
          <div
            onClick={() => {
              setShowSubMenu(!showSubMenu);
            }}
            key={data.key}
            className={
              'hover:dark:text-gray-400 text-black dark:text-white hover:text-gray-600 py-2.5 px-2 text-base hover:dark:bg-gray-500 hover:bg-gray-300 rounded'
            }
          >
            {data.label}
          </div>
          {showSubMenu && (
            <ul>
              {data.subMenus.map((item) => {
                return (
                  <li className="ml-4 mb-[10px]">
                    <a
                      onClick={() => {
                        item.key ? onClick(item.key) : window.open(item.link, '__blank');
                      }}
                      key={data.key}
                      className={
                        'hover:dark:text-gray-400 text-black dark:text-white hover:text-gray-600 py-2.5 px-2 text-[14px] hover:dark:bg-gray-500 hover:bg-gray-300 rounded'
                      }
                    >
                      {item.label}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ) : (
        <>
          <a
            id={data?.id}
            onClick={() => {
              data.key ? onClick(data.key) : window.open(data.link, '__blank');
            }}
            key={data.key}
            className={
              'flex items-center hover:dark:text-gray-400 text-black dark:text-white hover:text-gray-600 py-2.5 px-2 text-base hover:dark:bg-gray-500 hover:bg-gray-300 rounded'
            }
          >
            {data.label}
            {data?.isNew && (
              <span className="h-auto ml-2 bg-green-500 text-white text-[10px] px-3 rounded-full font-semibold shadow">
                {t('New')}
              </span>
            )}
          </a>
        </>
      )}
    </>
  );
};

export default MenuItem;
